// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { AlertTriangle as RawAlertTriangle } from "lucide-react";
export const AlertTriangle = /* @__PURE__ */ createIcon(RawAlertTriangle, "AlertTriangle", 2);
